export async function exportWorkbookBlob(workbookRef) {
  const { transformFortuneToExcel } = await import('@corbe30/fortune-excel');
  return transformFortuneToExcel(workbookRef, 'xlsx', false);
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
